import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import classNames from 'classnames';

const styles = {
  iconSmall: {
    padding: '0px',
    fontSize: 16
  },
  smallButton: {
    width: '100%',
    backgroundColor: 'white',
    borderRadius: 0,
    padding: '8px',
    height: 40,
    justifyContent: 'flex-start',
    color: '#2196f3'
  },

  smallButtonClose: {
    width: '100%',
    backgroundColor: 'white',
    borderRadius: 0,
    padding: '8px',
    height: 40,
    justifyContent: 'center',
    color: '#2196f3'
  },
  text: {
    fontSize: 12,
    fontWeight: 600,
    marginLeft: 16,
    color: 'rgba(0, 0, 0, 0.87)'
  },
  currentMenu: {
    backgroundColor: '#2196f3',
    color: '#ffffff',

    '&:hover, &:focus': {
      backgroundColor: '#2196f3',
      color: '#ffffff'
    },
    '& div': {
      color: '#ffffff'
    }
  }
};

const enhance = compose(pure);

const button = enhance(
  ({ classes, classStyle, label, onClickAction, open, currentRoute }) => {
    const currentMenu = currentRoute === window.location.pathname;
    return (
      <Button
        className={classNames(
          open ? classes.smallButton : classes.smallButtonClose,
          currentMenu ? classes.currentMenu : ''
        )}
        onClick={() => {
          onClickAction();
        }}
      >
        <i className={`${classStyle} ${classes.iconSmall}`} />
        {open && <div className={classes.text}>{label}</div>}
      </Button>
    );
  }
);

export default withStyles(styles)(button);
